import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimChapterEnum, BimWorkOrderChangePriceStatesData } from 'gql/graphql';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangePriceStatesGql } from '../workOrderChangeQueries';

const requestId = 'bimWorkOrderChangePriceStates';

type TProps = {
    workOrderChangeId: number;
    workOrderObjectId: number | undefined;
    workOrderChangeObjectId: number | undefined;
    chapter: BimChapterEnum;
};

export const useBimWorkOrderChangePriceStates = ({
    workOrderChangeId,
    workOrderObjectId,
    workOrderChangeObjectId,
    chapter,
}: TProps) => {
    const dispatch = useDispatch();

    const [bimWorkOrderChangePriceStatesReset] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => ({
            workOrderChangeId,
            workOrderObjectId,
            workOrderChangeObjectId,
            chapter,
        }),
        [chapter, workOrderChangeId, workOrderChangeObjectId, workOrderObjectId],
    );

    const [bimWorkOrderChangePriceStatesData, , , bimWorkOrderChangePriceStatesRequest] = useRequest({
        requestId,
        query: bimWorkOrderChangePriceStatesGql,
        variables,
        withEffect: true,
    });

    const bimWorkOrderChangePriceStatesMakeRequest = useCallback(() => {
        dispatch(bimWorkOrderChangePriceStatesRequest(variables));
    }, [bimWorkOrderChangePriceStatesRequest, dispatch, variables]);

    const data = useMemo(
        () =>
            bimWorkOrderChangePriceStatesData?.bimWorkOrderChangePriceStates?.data ||
            ({} as BimWorkOrderChangePriceStatesData),
        [bimWorkOrderChangePriceStatesData?.bimWorkOrderChangePriceStates?.data],
    );

    useEffect(() => {
        bimWorkOrderChangePriceStatesReset(undefined);
    }, [bimWorkOrderChangePriceStatesReset]);

    return {
        bimWorkOrderChangePriceStatesData: data,
        bimWorkOrderChangePriceStatesMakeRequest,
    };
};
